export const ExploreImagePanelLabel = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <span className="font-plex-mono text-[10px] uppercase tracking-[0.2em] text-[#77787A]">
    {children}
  </span>
);
